module.exports = __webpack_public_path__ + "media/images/hankyu_hakone_zh02-9f1423609983969c09ecf1e3b958506b.jpg";